import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/thegrinder/react-handy-hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "react-handy-hooks"
    }}>{`react-handy-hooks`}</h1>
    <p><a parentName="p" {...{
        "href": "https://opensource.org/licenses/MIT"
      }}><img alt="License: MIT" src="https://img.shields.io/badge/License-MIT-yellow.svg" /></a>{` `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/react-handy-hooks"
      }}><img alt="version" src="https://img.shields.io/npm/v/react-handy-hooks.svg?style=flat" /></a>{` `}<a parentName="p" {...{
        "href": "https://travis-ci.org/thegrinder/react-handy-hooks"
      }}><img alt="Build Status" src="https://travis-ci.org/thegrinder/react-handy-hooks.svg?branch=master" /></a>{` `}<a parentName="p" {...{
        "href": "https://github.com/semantic-release/semantic-release"
      }}><img alt="semantic-release" src="https://img.shields.io/badge/%20%20%F0%9F%93%A6%F0%9F%9A%80-semantic--release-e10079.svg" /></a>{` `}<a parentName="p" {...{
        "href": "https://codecov.io/gh/thegrinder/react-handy-hooks"
      }}><img alt="Codecov" src="https://img.shields.io/codecov/c/github/thegrinder/react-handy-hooks.svg" /></a></p>
    <p>{`react-handy-hooks is a collection of react hooks that make building components easier and quicker.`}</p>
    <p><a parentName="p" {...{
        "href": "https://thegrinder.github.io/react-handy-hooks"
      }}>{`https://thegrinder.github.io/react-handy-hooks`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      